import PanelRegistry from './PanelRegistry';

/**
 * @typedef {string} FilterId
 */

/**
 * @typedef PanelCatalogEntry
 * @property {string} [category] The optional category of the panel in the panel catalog. See
 * `PANEL_CATEGORIES` in `PanelRegistry.jsx`.
 * @property {int} [priority] The optional priority of the panel within the panel category. See
 * `PANEL_PRIORITIES` in `PanelRegistry.jsx`.
 * @property {string} [title] The title to display for the panel in the panel catalog.
 * @property {string} [description] The description to display for the panel in the panel catalog.
 * @property {boolean} [ipm] Denotes whether this panel is related to Infrastructure Performance Monitoring
 * will control whether or not the panel is hidden with IPM is disabled
 */

/**
 * @typedef PanelOptions
 * @property {string} [typeAlias] An optional alias for the panel.  Used to map legacy panel IDs to
 * the new panel component type.
 * @property {PanelCatalogEntry} [catalogEntry] An optional descriptor of the panel's catalog entry.  The panel
 * will not be shown in the catalog if a catalog entry is not specified.
 * @property {object} filters A descriptor of the panel's filter requirements.
 * @property {FilterId[]} [filters.required] An array of filter IDs for the panel's required filters.
 * @property {FilterId[]} [filters.optional] An array of filter IDs for the panel's optional filters.
 */

/**
 * @typedef WrappedPanelComponentProps
 * @property {boolean} [hideTitle]
 * @property {boolean} [flexHeight]
 */

/**
 * @typedef {(props?: WrappedPanelComponentProps) => React.ReactElement} WrappedPanelComponent
 */

/**
 * A decorator used to register panels with the page framework.
 *
 * @param {PanelOptions} [options] The decorator options
 * @returns {(component: React.FunctionComponent<null>) => React.FunctionComponent<WrappedPanelComponentProps>}
 */
export default function Panel(options = {}) {
    return (panelType) => {
        PanelRegistry.registerPanel(options, panelType);
        return panelType;
    };
}
